import { gql, useQuery } from '@apollo/client';
import { OnlineOrderReportTopProductItem } from '@client/graphql/types/graphql';

interface OnlineOrderTopProductsData {
  onlineOrderReport_owner_getTopProducts: OnlineOrderReportTopProductItem[];
}

interface OnlineOrderTopProductsVars {
  branchId: string;
  dateRange: {
    startDate: string;
    endDate: string;
  };
  limit?: number;
}

const ONLINE_ORDER_TOP_PRODUCTS_QUERY = gql`
  query OnlineOrderReportTopProducts($branchId: ID!, $dateRange: OnlineOrderReportDateRangeInput!, $limit: Int) {
    onlineOrderReport_owner_getTopProducts(branchId: $branchId, dateRange: $dateRange, limit: $limit) {
      productId
      productName
      totalQuantitySold
      totalRevenue
    }
  }
`;

export default function useOnlineOrderTopProducts(branchId: string, startDate: string, endDate: string, limit: number) {
  return useQuery<OnlineOrderTopProductsData, OnlineOrderTopProductsVars>(ONLINE_ORDER_TOP_PRODUCTS_QUERY, {
    variables: {
      branchId,
      dateRange: {
        startDate,
        endDate,
      },
      limit,
    },
    skip: !branchId || !startDate || !endDate,
  });
}
